<script>
import filterPills from './filter-pills.vue'
import talkNavbar from './talk-navbar.vue'
import talkTimeTable from './time-table.vue'
import talkListMixin from './talk-list-mixin.js'
import {SpeakerMixin} from '../lib/speaker-utils.js'

export default {
  components: {filterPills, talkTimeTable, talkNavbar},
  mixins: [talkListMixin, SpeakerMixin],
  props: ['eventShortName'],

  data() {
    return {
      filter:  {
        location: [],
        streams: [],
        language: [],
        content_code: [],
        talk_type: [],
      },
      filterKeys: ['search', 'day', 'favorites', 'history'],
      filterListKeys: ['location', 'streams', 'language', 'content_code', 'talk_type'],

      locations: [],
      languages: [],
      streams: [],
      talkTypes: [],
      events: [],
      numFavorites: 0,
      numEvents: 0,
      eventDays: {},
      response: undefined,
      numPages: 1,
      timelineActive: this.$route.query.view,
      navbarToolButtons: [
          { label: 'Liste / Timeline', icon: 'fas fa-calendar-alt', fn: this.toggleTimeline },
          { label: 'Favoriten', icon: 'far fa-bookmark', fn: this.toggleFavorites },
          { label: 'History', icon: 'fas fa-history', fn: this.toggleHistory },
      ],
      navbarMenuItems: [
          {
            label: 'Export',
            items: [
              { label: 'Download/Print', fn: this.clickMarkedPrintView },
              { label: 'in Kalender', fn: this.clickMarkedIcsView },
            ]
          },
      ],
    }
  },

  computed: {
    favoriteMode() { return this.eventShortName == undefined || !navigator.onLine },
    routeQueryHasFavorites() { return this.$route.query && this.$route.query.favorites },
    filteredDays() {
      if (!this.eventDays || !this.eventDays.length) return []
      let today = new Date().toISOString().split('T')[0]
      if (this.filter.history)
        return this.eventDays.filter(d => d < today)
      return this.eventDays.filter(d => d >= today)
    },
  },

  created() {
    this.getFavorites()
    this.buildFilterFromQuery()
    if (this.filter.favorites)
        this.$set(this.navbarToolButtons[1], 'icon', 'fa fa-bookmark')
    if (this.filter.history)
        this.$set(this.navbarToolButtons[2], 'icon', 'fas fa-history text-primary')

    let me = this
    this.fetchLocations().then(() => {
      me.fetchDays().then(() => {
        /*
        // set first day as default
        if (!me.favoriteMode && !me.filter.day && !me.filter.content_code?.length)
          me.filter.day = me.eventDays[0]
        */
        me.fetchLanguages().then(() => {
          me.fetchStreams().then(() => {
            me.fetchTalkTypes().then(() => {
              me.fetchEvents(me.filter)
            })
          })
        })
      })
    })
  },

  methods: {

    pushQuery(query) {
      try {
        this.$router.push({query: query})
      } catch(error) {
        console.error(error)
      }
    },

    buildFilterFromQuery() {
      this.emptyFilter()
      for (let k of this.filterKeys) {
        if (this.$route.query && this.$route.query[k] != undefined) {
          this.filter[k] = this.$route.query[k]
        }
      }
      for (let k of this.filterListKeys) {
        if (this.$route.query && this.$route.query[k] != undefined) {
          let v = this.$route.query[k]
          this.filter[k] = Array.isArray(v) ? [...v] : [v]
        }
      }
    },

    buildQuery() {
      let query = {}
      for (let k of this.filterListKeys) {
        if (this.filter[k] && this.filter[k].length)
          query[k] = this.filter[k]
      }
      for (let k of this.filterKeys) {
        if (this.filter[k])
          query[k] = this.filter[k]
      }
      return query
    },

    emptyFilter() {
      for (let k of this.filterListKeys)
        this.$set(this.filter, k, [])
      for (let k of this.filterKeys)
        this.filter[k] = undefined
    },

    toggleListFilter(list, value) {
      if (list.includes(value)) {
        let i = list.indexOf(value)
        list.splice(i, 1)
      } else {
        list.push(value)
      }
    },

    applyFilter: function (filterKey, value) {
      if (this.filterListKeys.includes(filterKey)) {
        this.toggleListFilter(this.filter[filterKey], value)
      } else {
        if (value)
          this.filter[filterKey] = value
        else
          delete this.filter[filterKey]
      }

      this.fetchEvents(this.filter)

      let query = this.buildQuery()
      this.pushQuery(query)
    },

    resetFilter() {
      this.emptyFilter()
      this.pushQuery({})
      this.fetchEvents()
    },

    toggleTimeline() {
      this.timelineActive = !this.timelineActive
      try {
        if (this.timelineActive) {
          this.pushQuery({ ...this.$route.query, 'view': 'timeline' })
        } else {
          let query = {...this.$route.query}
          delete query.view
          this.pushQuery(query)
        }
      } catch(error) {
        console.error(error)
      }
    },

    filterDay(day) {
        if (this.filter.day === day)
          this.applyFilter('day', '')
        else
          this.applyFilter('day', day)
    },

    speakerFullName: function (speaker) {
      return [speaker.title, speaker.first_name, speaker.last_name].join(' ').trim()
    },

    parseDate: function (datetimeStr, locale = 'de') {
      const opts = {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    displayTime(datetimeStr, locale = 'de') {
      const opts = {
        hour: "numeric",
        minute: "numeric",
        timeZone: 'Europe/Berlin',
      }
      return new Date(datetimeStr).toLocaleString(locale, opts)
    },

    fetchEvents(filter) {
      let me = this
      let params = {...filter}
      let payload = {}

      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          this.events = []
          this.numEvents = 0
          return Promise.resolve({data: {'results': me.events, 'count': me.numEvents }})
        }
      } else {
        if (!Object.prototype.hasOwnProperty.call(params, 'event_short_name'))
          params['event_short_name'] = this.eventShortName.toUpperCase()
      }

      if (navigator.onLine) {
        if (this.favoriteMode || params.favorites === "1") {
          payload['content_code'] = this.getFavorites()
          delete params.favorites
        }
        return this.$api.post('/session-index/', payload, {params: params}).then(response => {
          me.events = response.data.results
          me.numEvents = response.data.count

          if (me.favoriteMode && !params.history) {
            // Sort current/future favorites ascending (next session first)
            me.events = me.events.sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime))
            // Auto-activate history if no current/future favorites
            if (me.numEvents === 0 && !me.filter.history) {
              me.filter.history = "1"
              me.$set(me.navbarToolButtons[me.navbarToolButtons.length - 1], 'icon', 'fas fa-history text-primary')
              return me.fetchEvents(me.filter)
            }
          }

          // Extract unique days from fetched sessions for day filter pills
          if (me.favoriteMode) {
            let days = new Set()
            for (let e of me.events) {
              days.add(e.start_datetime.split('T')[0])
            }
            me.eventDays = [...days].sort()
          }

          return response
        })
      } else {
        this.events = Object.values(this.$storage.getItem('sessions', []))
        this.numEvents = this.events.length
        return Promise.resolve({data: {'results': me.events, 'count': this.numEvents }})
      }
    },

    fetchLocations() {
      let me = this
      if (this.favoriteMode)
        return Promise.resolve({data:[]})
      let params = {event_short_name: this.eventShortName.toUpperCase()}
      return this.$api.get('/locations/', {params: params}).then(response => {
        me.locations = response.data
        return response
      })
    },

    fetchStreams() {
      let me = this
      if (this.favoriteMode)
        return Promise.resolve({data:[]})
      let params = {event_short_name: this.eventShortName.toUpperCase()}
      return this.$api.get('/stream/', {params: params}).then(response => {
        me.streams = response.data
        return response
      })
    },

    fetchDays() {
      if (this.favoriteMode)
        return Promise.resolve({data:[]})
      let me =  this
      let params = {event_short_name: this.eventShortName.toUpperCase()}
      return this.$api.get('/session-dates/', {params: params}).then(response => {
        me.eventDays = response.data
        return response
      })
    },

    fetchLanguages() {
      if (this.favoriteMode)
        return Promise.resolve({data:[]})
      let me =  this
      let params = {event_short_name: this.eventShortName.toUpperCase()}
      return this.$api.get('/session-languages/', {params: params}).then(response => {
        me.languages = response.data
        return response
      })
    },

    fetchTalkTypes() {
      if (this.favoriteMode)
        return Promise.resolve({data: []})
      let me = this
      let params = {event_short_name: this.eventShortName.toUpperCase()}
      return this.$api.get('/session-talk-types/', {params: params}).then(response => {
        me.talkTypes = response.data
        return response
      })
    },

    clickMarkedPrintView: function () {
      if (this.events.length > 200)
        alert('Export ist limitiert auf 200 sessions.')
      let codes = this.events.map(event => event.content_code).slice(0, 200).join(',')
      const url = `${this.$backendUrl}api/print-sessions/?content_code=${codes}`
      window.open(url, '_blank')
    },

    clickMarkedIcsView: function () {
      if (this.events.length > 200)
        alert('Export ist limitiert auf 200 sessions.')
      let codes = this.events.map(event => event.content_code).slice(0, 200).join(',')
      const url = `${this.$backendUrl}api/ics-sessions/?content_code=${encodeURIComponent(codes)}`
      window.location.href = url
      // window.open(url, '_blank')
    },

    toggleFavorites: function () {
      if (this.filter.favorites) {
        this.filter.favorites = undefined
        this.$set(this.navbarToolButtons[1], 'icon', 'far fa-bookmark')
      } else {
        this.emptyFilter()
        this.filter.favorites = "1"
        this.$set(this.navbarToolButtons[1], 'icon', 'fa fa-bookmark')
      }
      this.fetchEvents(this.filter)
      let query = this.buildQuery()
      this.pushQuery(query)
    },

    toggleHistory: function () {
      if (this.filter.history) {
        this.filter.history = undefined
        this.$set(this.navbarToolButtons[2], 'icon', 'fas fa-history')
      } else {
        this.filter.history = "1"
        this.$set(this.navbarToolButtons[2], 'icon', 'fas fa-history text-primary')
      }
      this.fetchEvents(this.filter)
      let query = this.buildQuery()
      this.pushQuery(query)
    },

    getTalkDetail(talk) {
      let me = this
      this.$api.get(`/sessions/${talk.id}/`).then(function(response) {
        let index = me.events.findIndex(t => t.content_code === talk.content_code)
        me.$set(me.events, index, response.data)
      })
    }
  },
}
</script>

<template>
<div>
<toast v-if="toastMessage" :message="toastMessage" @closed="toastMessage=''"/>
<talk-navbar class="mb-1"
  :fav-mode="favoriteMode"
  :locations="locations"
  @toggle-location="applyFilter('location', $event.id)"

  :streams="streams"
  @toggle-stream="applyFilter('streams', $event.id)"

  :languages="languages"
  @toggle-language="applyFilter('language', $event)"

  :talk-types="talkTypes"
  @toggle-talk-type="applyFilter('talk_type', $event.id)"

  :filter="filter"
  @search="applyFilter('search', $event)"
  @delete-search="applyFilter('search', '')"

  :menu-items="navbarMenuItems"
  :tool-buttons="navbarToolButtons"
/>
<div class="d-flex justify-content-start mb-2 align-items-center">
  <small class="text-muted me-1">{{ numFavorites }} Favoriten / {{numEvents}} Treffer<template
    v-if="favoriteMode && !filter.history && numFavorites > numEvents"
  > / {{ numFavorites - numEvents }} Frühere</template></small>
  <filter-pills :filterValues="filter.location" :values="locations"
   @delete="applyFilter('location', $event)" />
  <filter-pills :filterValues="filter.language"
   @delete="applyFilter('language', $event)" />
  <filter-pills :filterValues="filter.streams" :values="streams"
   @delete="applyFilter('streams', $event)" />
  <filter-pills :filterValues="filter.talk_type" :values="talkTypes"
   @delete="applyFilter('talk_type', $event)" />

  <span v-if="!favoriteMode && routeQueryHasFavorites"
    class="badge badge-pill bg-warning me-1">
    Favoriten
    <a href="#" class="text-decoration-none" @click.prevent="resetFilter()">
      <i class="fas fa-times-circle"></i>
    </a>
  </span>
  <span v-if="filter.history"
    class="badge badge-pill bg-info me-1">
    History
    <a href="#" class="text-decoration-none" @click.prevent="toggleHistory()">
      <i class="fas fa-times-circle"></i>
    </a>
  </span>
</div>

<section class="c-list-view">
  <nav class="nav nav-pills flex-wrap mb-3">
    <a v-for="(value, index) in filteredDays" :key="index"
        class="nav-link nav-item mb-1" :class="{active: filter.day == value}"
        href="#"
        @click.prevent="filterDay(value)"
        style="font-size: 1.5rem"
    >
      {{parseDate(value)}}
    </a>
  </nav>
  <div v-if="events.length > 0" class="event-container">
    <template v-if="timelineActive">
      <div class="mb-5">
          <talk-time-table
            :event-short-name="eventShortName"
            :events="events"
            @favorite-changed="getFavorites()"
            @stream="applyFilter('streams', $event.id)"
          ></talk-time-table>
      </div>
    </template>
    <template v-else>
    <div v-for="talk in events" :key="talk.id">
      <talk-detail :talk="talk"
      :language-display="languages.length > 0"
      :show-event-name="favoriteMode"
      @favorite-changed="onFavoriteChanged($event)"
      @talk-detail-required="getTalkDetail(talk)"
      @stream="applyFilter('streams', $event.id)"
      @speaker-click="$router.push(speakerUrl($event))"
      :list-display="true"
      />
      <hr style="border-color:lightgrey">
    </div>

    </template>
  </div>
  <template v-else>
    <div class="text-center">-- keine Treffer --</div>
  </template>
</section>
</div>
</template>

<style scoped>
.event-container {
  min-height: 70vh;
}
.badge {
  text-decoration: none;
}

button {
  border: none;
  background: none;
  cursor: pointer;
}
</style>
